export interface ComicChapter {
  id: string;
  title: string;
  number: number;
  updateTime: string;
}

export interface Comic {
  id: string;
  title: string;
  author: string;
  coverImage: string;
  description: string;
  fullDescription: string;
  category: string;
  categorySlug: string;
  status: '连载中' | '已完结';
  rating: number;
  totalViews: number;
  totalChapters: number;
  updateTime: string;
  tags: string[];
  chapters: ComicChapter[];
}

export interface Category {
  name: string;
  slug: string;
  description: string;
  count: number;
}

export interface Banner {
  id: string;
  comicId: string;
  title: string;
  subtitle: string;
  imageUrl: string;
  tag: string;
}

export const categories: Category[] = [
  { name: '奇幻冒险', slug: 'fantasy-adventure', description: '穿越异世界，开启奇幻冒险之旅', count: 43 },
  { name: '恋爱言情', slug: 'romance', description: '甜蜜动人的浪漫爱情故事', count: 58 },
  { name: '动作热血', slug: 'action', description: '热血沸腾的战斗场面，激情澎湃', count: 37 },
  { name: '悬疑推理', slug: 'mystery', description: '扣人心弦的悬疑故事，烧脑推理', count: 25 },
  { name: '古风奇幻', slug: 'ancient-fantasy', description: '古风韵味与奇幻元素的完美结合', count: 31 },
  { name: '搞笑日常', slug: 'comedy', description: '轻松幽默的日常故事，笑料不断', count: 29 },
];

export const banners: Banner[] = [
  {
    id: 'banner-1',
    comicId: 'comic-1',
    title: '剑与魔法',
    subtitle: '古风与奇幻的完美融合，带你走进宏大的东方玄幻世界',
    imageUrl: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20fantasy%20illustration%20of%20a%20warrior%20with%20a%20sword%20standing%20on%20a%20misty%20mountain%20peak%2C%20traditional%20ink%20painting%20style%20with%20warm%20cinnabar%20red%20and%20gold%20accents%2C%20ethereal%20atmosphere%2C%20soft%20gradient%20background%2C%20artistic%20illustration%2C%20digital%20painting%20with%20traditional%20Chinese%20aesthetic%2C%20jagged%20peaks%20in%20mist%2C%20flowing%20robes%2C%20cinematic%20lighting%2C%20warm%20golden%20hour%20tones%2C%20no%20text&width=1600&height=700&seq=gufeng-banner-1&orientation=landscape',
    tag: '热门推荐',
  },
  {
    id: 'banner-2',
    comicId: 'comic-5',
    title: '花间集',
    subtitle: '一段跨越时空的浪漫爱情，古风画风美到窒息',
    imageUrl: 'https://readdy.ai/api/search-image?query=Romantic%20ancient%20Chinese%20style%20illustration%20of%20a%20couple%20under%20blooming%20cherry%20blossom%20trees%2C%20traditional%20hanfu%20clothing%2C%20soft%20pink%20and%20gold%20color%20palette%2C%20dreamy%20atmosphere%2C%20petals%20falling%2C%20ink%20wash%20painting%20style%2C%20ethereal%20lighting%2C%20romantic%20scene%2C%20traditional%20Chinese%20aesthetic%2C%20warm%20and%20gentle%20tones%2C%20no%20text&width=1600&height=700&seq=gufeng-banner-2&orientation=landscape',
    tag: '新作上线',
  },
  {
    id: 'banner-3',
    comicId: 'comic-8',
    title: '暗夜追踪',
    subtitle: '悬疑烧脑力作，每一页都让你欲罢不能',
    imageUrl: 'https://readdy.ai/api/search-image?query=Mysterious%20ancient%20Chinese%20noir%20illustration%2C%20a%20detective%20figure%20in%20traditional%20robes%20walking%20through%20a%20misty%20night%20alley%20lit%20by%20red%20lanterns%2C%20ink%20painting%20style%2C%20dramatic%20shadows%2C%20warm%20amber%20lantern%20light%20contrasting%20with%20dark%20surroundings%2C%20atmospheric%2C%20suspenseful%20mood%2C%20traditional%20Chinese%20architecture%2C%20foggy%20night%20scene%2C%20cinematic%20composition%2C%20no%20text&width=1600&height=700&seq=gufeng-banner-3&orientation=landscape',
    tag: '口碑佳作',
  },
];

export const comics: Comic[] = [
  {
    id: 'comic-1',
    title: '剑与魔法',
    author: '墨染青衣',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20stunning%20Korean%20manhwa%20style%20cover%20illustration%20of%20a%20male%20warrior%20with%20long%20black%20hair%20holding%20a%20glowing%20sword%2C%20ancient%20Chinese%20fantasy%20setting%2C%20misty%20mountains%20background%2C%20warm%20cinnabar%20red%20and%20gold%20color%20scheme%2C%20digital%20painting%2C%20clean%20composition%2C%20simple%20gradient%20background%2C%20soft%20lighting%2C%20professional%20illustration&width=600&height=800&seq=gufeng-cover-1&orientation=portrait',
    description: '一个普通的少年，意外获得了上古神剑的传承，从此踏上了一条充满危险与奇遇的修炼之路。',
    fullDescription: '在古老的东方大陆，传说有一柄名为"天渊"的神剑，拥有改天换地的力量。少年林风在一次意外中获得了这柄神剑的传承，从此他的命运发生了翻天覆地的变化。在这个充满妖兽、魔法与阴谋的世界中，他必须不断变强，保护自己所珍视的一切。这是一部融合了东方玄幻与古风美学的史诗级作品，画风精致细腻，剧情跌宕起伏，带你领略一个宏大而神秘的奇幻世界。',
    category: '奇幻冒险',
    categorySlug: 'fantasy-adventure',
    status: '连载中',
    rating: 4.8,
    totalViews: 1258000,
    totalChapters: 156,
    updateTime: '2026-08-03',
    tags: ['玄幻', '热血', '成长', '剑修'],
    chapters: [
      { id: 'ch-1-1', title: '第一章：天降神剑', number: 1, updateTime: '2025-01-15' },
      { id: 'ch-1-2', title: '第二章：初入宗门', number: 2, updateTime: '2025-01-22' },
      { id: 'ch-1-3', title: '第三章：试炼之路', number: 3, updateTime: '2025-01-29' },
      { id: 'ch-1-150', title: '第一百五十章：剑意通明', number: 150, updateTime: '2026-07-20' },
      { id: 'ch-1-151', title: '第一百五十一章：天渊觉醒', number: 151, updateTime: '2026-07-27' },
      { id: 'ch-1-152', title: '第一百五十二章：破境之战', number: 152, updateTime: '2026-08-03' },
    ],
  },
  {
    id: 'comic-2',
    title: '星落九天',
    author: '云中君',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20beautiful%20Korean%20manhwa%20cover%20illustration%20of%20a%20female%20mage%20with%20silver%20hair%20surrounded%20by%20floating%20stars%20and%20magical%20particles%2C%20fantasy%20setting%2C%20deep%20cosmic%20background%20with%20golden%20accents%2C%20clean%20composition%2C%20soft%20ethereal%20lighting%2C%20professional%20digital%20illustration&width=600&height=800&seq=gufeng-cover-2&orientation=portrait',
    description: '九重天外，星辰坠落，一位少女的命运与星空紧密相连。',
    fullDescription: '九重天之上，星辰有序运转了千万年。直到那一天，一颗流星划破夜空，坠入凡间。少女星瑶从小便能看见常人看不见的星光，这份特殊的能力让她被卷入了天界与人间的纷争之中。在寻找真相的旅途中，她将遇见命中注定的伙伴与敌人，揭开一个关于星辰起源的惊天秘密。画风唯美飘逸，星辰场景令人叹为观止。',
    category: '奇幻冒险',
    categorySlug: 'fantasy-adventure',
    status: '连载中',
    rating: 4.7,
    totalViews: 983000,
    totalChapters: 89,
    updateTime: '2026-08-02',
    tags: ['玄幻', '星空', '冒险', '女性主角'],
    chapters: [
      { id: 'ch-2-1', title: '第一章：流星之夜', number: 1, updateTime: '2025-06-01' },
      { id: 'ch-2-2', title: '第二章：星光指引', number: 2, updateTime: '2025-06-08' },
      { id: 'ch-2-85', title: '第八十五章：星辰之门', number: 85, updateTime: '2026-07-25' },
      { id: 'ch-2-86', title: '第八十六章：九天之上', number: 86, updateTime: '2026-08-02' },
    ],
  },
  {
    id: 'comic-3',
    title: '灵墟纪元',
    author: '江山如画',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20illustration%20of%20a%20young%20man%20with%20determined%20expression%20in%20martial%20arts%20pose%2C%20ancient%20oriental%20temple%20ruins%20background%2C%20warm%20earthy%20brown%20and%20gold%20tones%2C%20clean%20composition%2C%20soft%20dramatic%20lighting%2C%20professional%20digital%20illustration&width=600&height=800&seq=gufeng-cover-3&orientation=portrait',
    description: '灵气复苏的时代，少年凭借一本古老功法，在乱世中崛起。',
    fullDescription: '上古灵墟重现人间，天地灵气开始复苏。在这个大时代中，平凡少年陈凡意外获得了一本来自灵墟的古老功法。从此，他的命运与这个波澜壮阔的时代紧密交织。各方势力明争暗斗，古老的秘密逐渐浮出水面。这不仅是一部修炼变强的故事，更是一个关于信念与抉择的史诗传奇。',
    category: '奇幻冒险',
    categorySlug: 'fantasy-adventure',
    status: '连载中',
    rating: 4.6,
    totalViews: 756000,
    totalChapters: 67,
    updateTime: '2026-08-01',
    tags: ['灵气复苏', '修炼', '热血', '冒险'],
    chapters: [
      { id: 'ch-3-1', title: '第一章：灵墟现世', number: 1, updateTime: '2025-08-10' },
      { id: 'ch-3-2', title: '第二章：古籍之谜', number: 2, updateTime: '2025-08-17' },
      { id: 'ch-3-63', title: '第六十三章：古战场', number: 63, updateTime: '2026-07-18' },
      { id: 'ch-3-64', title: '第六十四章：觉醒之力', number: 64, updateTime: '2026-08-01' },
    ],
  },
  {
    id: 'comic-4',
    title: '魔道祖师',
    author: '墨香铜臭',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20cover%20of%20a%20mysterious%20dark-haired%20man%20in%20flowing%20black%20robes%20with%20red%20accents%2C%20ancient%20Chinese%20dark%20fantasy%20setting%2C%20crimson%20spiritual%20energy%20surrounding%20him%2C%20clean%20composition%2C%20dramatic%20contrast%20lighting%2C%20professional%20digital%20illustration&width=600&height=800&seq=gufeng-cover-4&orientation=portrait',
    description: '一代魔道至尊重生归来，这一世他要改写命运。',
    fullDescription: '他是令天下闻风丧胆的魔道祖师，却在渡劫之时被至亲背叛，魂飞魄散。三百年后，他重生于一个废材少年的身上。带着前世的记忆与不甘，他决定重新踏上修炼之路。这一世，他要让所有背叛他的人付出代价，也要找到那个在他最黑暗时刻给予他温暖的人。画风凌厉霸气，战斗场面震撼人心。',
    category: '奇幻冒险',
    categorySlug: 'fantasy-adventure',
    status: '已完结',
    rating: 4.9,
    totalViews: 2150000,
    totalChapters: 210,
    updateTime: '2026-06-15',
    tags: ['重生', '魔道', '复仇', '热血'],
    chapters: [
      { id: 'ch-4-1', title: '第一章：陨落', number: 1, updateTime: '2024-03-01' },
      { id: 'ch-4-2', title: '第二章：重生', number: 2, updateTime: '2024-03-08' },
      { id: 'ch-4-206', title: '第二百零六章：最终之战（上）', number: 206, updateTime: '2026-05-20' },
      { id: 'ch-4-207', title: '第二百零七章：最终之战（中）', number: 207, updateTime: '2026-06-01' },
      { id: 'ch-4-208', title: '第二百零八章：最终之战（下）', number: 208, updateTime: '2026-06-08' },
      { id: 'ch-4-209', title: '第二百零九章：新的开始', number: 209, updateTime: '2026-06-15' },
      { id: 'ch-4-210', title: '第二百一十章：尾声·归途', number: 210, updateTime: '2026-06-15' },
    ],
  },
  {
    id: 'comic-5',
    title: '花间集',
    author: '清风抚月',
    coverImage: 'https://readdy.ai/api/search-image?query=Romantic%20Korean%20manhwa%20cover%20of%20a%20beautiful%20woman%20in%20traditional%20hanfu%20dress%20among%20cherry%20blossoms%2C%20soft%20pink%20and%20cream%20color%20palette%2C%20dreamy%20romantic%20atmosphere%2C%20clean%20composition%2C%20gentle%20lighting%2C%20professional%20illustration&width=600&height=800&seq=gufeng-cover-5&orientation=portrait',
    description: '花开花落间，一段跨越身份与世俗的浪漫爱情徐徐展开。',
    fullDescription: '京城第一才女沈若兰，因家族联姻被许配给素未谋面的将军之子。不甘命运的她女扮男装溜出府邸，却在花灯会上邂逅了一位神秘男子。两人一见如故，吟诗作对，共赏花灯。然而她不知道的是，这位让她心动的男子，正是她逃婚的对象。一段阴差阳错的浪漫爱情，在花开花落间悄然绽放。画风唯美精致，每一帧都如同一幅古风水墨画。',
    category: '恋爱言情',
    categorySlug: 'romance',
    status: '连载中',
    rating: 4.8,
    totalViews: 1670000,
    totalChapters: 98,
    updateTime: '2026-08-03',
    tags: ['古风', '恋爱', '甜宠', '女扮男装'],
    chapters: [
      { id: 'ch-5-1', title: '第一章：逃婚', number: 1, updateTime: '2025-04-01' },
      { id: 'ch-5-2', title: '第二章：花灯会', number: 2, updateTime: '2025-04-08' },
      { id: 'ch-5-94', title: '第九十四章：花落谁家', number: 94, updateTime: '2026-07-20' },
      { id: 'ch-5-95', title: '第九十五章：真心', number: 95, updateTime: '2026-08-03' },
    ],
  },
  {
    id: 'comic-6',
    title: '倾城之恋',
    author: '月下独酌',
    coverImage: 'https://readdy.ai/api/search-image?query=Elegant%20Korean%20manhwa%20cover%20of%20a%20graceful%20woman%20in%20flowing%20silk%20robes%20standing%20by%20a%20moonlit%20lake%2C%20ancient%20Chinese%20palace%20in%20distance%2C%20silver%20moonlight%2C%20romantic%20and%20melancholic%20mood%2C%20clean%20composition%2C%20soft%20cool%20lighting%20with%20warm%20highlights%2C%20professional%20illustration&width=600&height=800&seq=gufeng-cover-6&orientation=portrait',
    description: '一国之君与敌国公主，一段在战火中绽放的凄美爱情。',
    fullDescription: '她是敌国的公主，他是新登基的少年天子。一场战争让她成为了他的俘虏，却也成为了他心中无法抹去的朱砂痣。在宫廷的暗流涌动中，两颗孤独的心逐渐靠近。然而国仇家恨横亘在两人之间，这段感情注定充满荆棘。当爱情与责任发生冲突，他们将如何抉择？画风华美大气，宫廷场景精致细腻。',
    category: '恋爱言情',
    categorySlug: 'romance',
    status: '已完结',
    rating: 4.7,
    totalViews: 1890000,
    totalChapters: 120,
    updateTime: '2026-05-20',
    tags: ['古风', '虐恋', '宫廷', '深情'],
    chapters: [
      { id: 'ch-6-1', title: '第一章：城破', number: 1, updateTime: '2024-09-01' },
      { id: 'ch-6-2', title: '第二章：初见', number: 2, updateTime: '2024-09-08' },
      { id: 'ch-6-118', title: '第一百一十八章：归途', number: 118, updateTime: '2026-05-13' },
      { id: 'ch-6-119', title: '第一百一十九章：白首', number: 119, updateTime: '2026-05-20' },
      { id: 'ch-6-120', title: '第一百二十章：尾声', number: 120, updateTime: '2026-05-20' },
    ],
  },
  {
    id: 'comic-7',
    title: '武道至尊',
    author: '铁血丹心',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20action%20cover%20of%20a%20powerful%20martial%20artist%20mid-battle%20with%20dynamic%20energy%20effects%2C%20fierce%20expression%2C%20torn%20clothing%2C%20ancient%20arena%20background%2C%20warm%20orange%20and%20brown%20tones%2C%20clean%20composition%2C%20dramatic%20action%20lighting%2C%20professional%20illustration&width=600&height=800&seq=gufeng-cover-7&orientation=portrait',
    description: '以武为尊的世界，少年凭借钢铁意志一步步走向武道巅峰。',
    fullDescription: '在一个以武为尊的世界中，出身卑微的少年铁心凭借惊人的毅力和不屈的意志，在武道之路上不断突破。从默默无闻的杂役弟子，到名震天下的武道至尊，他用拳头打出了属于自己的传奇。每一场战斗都让人热血沸腾，每一次突破都令人心潮澎湃。这是一部纯粹而硬核的武道漫画，战斗分镜堪比电影级表现。',
    category: '动作热血',
    categorySlug: 'action',
    status: '连载中',
    rating: 4.6,
    totalViews: 1120000,
    totalChapters: 142,
    updateTime: '2026-08-02',
    tags: ['武道', '热血', '战斗', '成长'],
    chapters: [
      { id: 'ch-7-1', title: '第一章：杂役弟子', number: 1, updateTime: '2025-02-01' },
      { id: 'ch-7-2', title: '第二章：第一战', number: 2, updateTime: '2025-02-08' },
      { id: 'ch-7-138', title: '第一百三十八章：王者之战', number: 138, updateTime: '2026-07-18' },
      { id: 'ch-7-139', title: '第一百三十九章：巅峰对决', number: 139, updateTime: '2026-08-02' },
    ],
  },
  {
    id: 'comic-8',
    title: '暗夜追踪',
    author: '隐墨',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20mystery%20cover%20of%20a%20detective%20figure%20in%20a%20dark%20alley%20illuminated%20by%20a%20single%20lantern%2C%20noir%20atmosphere%2C%20ancient%20Chinese%20setting%2C%20shadows%20and%20mystery%2C%20warm%20amber%20light%20in%20darkness%2C%20clean%20composition%2C%20professional%20illustration&width=600&height=800&seq=gufeng-cover-8&orientation=portrait',
    description: '繁华古都暗藏杀机，一名神探抽丝剥茧追查连环命案。',
    fullDescription: '大梁京城，繁华之下暗流涌动。一连串离奇的命案打破了京城的宁静，死者之间看似毫无关联，却都留下了一个相同的符号。神探沈逸临危受命，在追查真凶的过程中，他发现自己正一步步走入一个巨大的阴谋之中。每一个线索都指向一个更加黑暗的真相。画风冷峻克制，悬疑氛围营造得恰到好处。',
    category: '悬疑推理',
    categorySlug: 'mystery',
    status: '连载中',
    rating: 4.5,
    totalViews: 678000,
    totalChapters: 54,
    updateTime: '2026-08-01',
    tags: ['悬疑', '推理', '古风', '探案'],
    chapters: [
      { id: 'ch-8-1', title: '第一章：血案', number: 1, updateTime: '2025-11-01' },
      { id: 'ch-8-2', title: '第二章：符号', number: 2, updateTime: '2025-11-08' },
      { id: 'ch-8-50', title: '第五十章：迷雾渐散', number: 50, updateTime: '2026-07-18' },
      { id: 'ch-8-51', title: '第五十一章：真凶浮现', number: 51, updateTime: '2026-08-01' },
    ],
  },
  {
    id: 'comic-9',
    title: '青灯古卷',
    author: '拾遗居士',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20mysterious%20cover%20of%20an%20ancient%20library%20with%20a%20figure%20reading%20by%20lantern%20light%2C%20old%20scrolls%20and%20books%2C%20warm%20amber%20glow%2C%20ancient%20Chinese%20setting%2C%20mysterious%20atmosphere%2C%20clean%20composition%2C%20professional%20illustration&width=600&height=800&seq=gufeng-cover-9&orientation=portrait',
    description: '一本神秘的古卷，揭开了一座千年古墓的惊天秘密。',
    fullDescription: '历史系研究生林砚在整理古籍时，偶然发现了一本记载着神秘符号的古老手卷。随着研究的深入，他发现这本手卷指向了一座从未被发现的千年古墓。然而，觊觎古墓秘密的势力远比他想象的更加庞大和危险。在追寻真相的道路上，每一个发现都在颠覆他对历史的认知。这是一部融合了历史、考古与悬疑的精彩作品。',
    category: '悬疑推理',
    categorySlug: 'mystery',
    status: '连载中',
    rating: 4.4,
    totalViews: 432000,
    totalChapters: 38,
    updateTime: '2026-07-30',
    tags: ['悬疑', '考古', '历史', '冒险'],
    chapters: [
      { id: 'ch-9-1', title: '第一章：古卷', number: 1, updateTime: '2026-01-10' },
      { id: 'ch-9-2', title: '第二章：符号之谜', number: 2, updateTime: '2026-01-17' },
      { id: 'ch-9-35', title: '第三十五章：地宫入口', number: 35, updateTime: '2026-07-23' },
      { id: 'ch-9-36', title: '第三十六章：千年守护', number: 36, updateTime: '2026-07-30' },
    ],
  },
  {
    id: 'comic-10',
    title: '九幽之巅',
    author: '墨染青衣',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20fantasy%20cover%20of%20a%20figure%20standing%20on%20a%20mountain%20peak%20overlooking%20a%20mystical%20ancient%20Chinese%20landscape%2C%20dragons%20in%20distant%20sky%2C%20misty%20mountains%2C%20golden%20and%20jade%20green%20accents%2C%20clean%20composition%2C%20epic%20scale%2C%20professional%20illustration&width=600&height=800&seq=gufeng-cover-10&orientation=portrait',
    description: '九幽之下，别有洞天。少年踏上通往九幽之巅的奇幻旅程。',
    fullDescription: '传说在世界的尽头，有一座通往九幽的巨峰。登上九幽之巅的人，可以实现任何一个愿望。少年叶辰为救身患绝症的妹妹，踏上了这条充满未知与危险的旅程。一路上，他遇见了形形色色的伙伴，也经历了无数生死考验。这不仅是一场冒险，更是一次关于成长、友情与勇气的洗礼。画风磅礴大气，场景宏大壮观。',
    category: '古风奇幻',
    categorySlug: 'ancient-fantasy',
    status: '连载中',
    rating: 4.7,
    totalViews: 876000,
    totalChapters: 76,
    updateTime: '2026-08-03',
    tags: ['古风', '奇幻', '冒险', '兄妹情'],
    chapters: [
      { id: 'ch-10-1', title: '第一章：启程', number: 1, updateTime: '2025-07-01' },
      { id: 'ch-10-2', title: '第二章：迷雾森林', number: 2, updateTime: '2025-07-08' },
      { id: 'ch-10-72', title: '第七十二章：云海之上', number: 72, updateTime: '2026-07-20' },
      { id: 'ch-10-73', title: '第七十三章：九幽之门', number: 73, updateTime: '2026-08-03' },
    ],
  },
  {
    id: 'comic-11',
    title: '仙路飘渺',
    author: '江山如画',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20of%20an%20immortal%20cultivator%20in%20white%20flowing%20robes%20surrounded%20by%20floating%20mist%20and%20spiritual%20energy%2C%20ancient%20Chinese%20celestial%20palace%20background%2C%20ethereal%20white%20and%20gold%20tones%2C%20clean%20composition%2C%20soft%20divine%20lighting%2C%20professional%20illustration&width=600&height=800&seq=gufeng-cover-11&orientation=portrait',
    description: '仙路漫漫，上下求索。一位凡人的修仙之路。',
    fullDescription: '在一个人人向往修仙的世界中，出身平凡的木匠之子苏白，因一次意外踏上了修仙之路。他没有显赫的家世，没有逆天的天赋，有的只是一颗永不言弃的求道之心。在这条漫长而孤独的修仙路上，他将面临无数的考验与抉择。画风清逸出尘，仙气十足，将东方仙侠美学展现得淋漓尽致。',
    category: '古风奇幻',
    categorySlug: 'ancient-fantasy',
    status: '已完结',
    rating: 4.8,
    totalViews: 1560000,
    totalChapters: 180,
    updateTime: '2026-04-10',
    tags: ['修仙', '古风', '成长', '仙侠'],
    chapters: [
      { id: 'ch-11-1', title: '第一章：木匠之子', number: 1, updateTime: '2024-06-01' },
      { id: 'ch-11-2', title: '第二章：灵根觉醒', number: 2, updateTime: '2024-06-08' },
      { id: 'ch-11-178', title: '第一百七十八章：飞升', number: 178, updateTime: '2026-04-03' },
      { id: 'ch-11-179', title: '第一百七十九章：仙界', number: 179, updateTime: '2026-04-10' },
      { id: 'ch-11-180', title: '第一百八十章：新的旅程', number: 180, updateTime: '2026-04-10' },
    ],
  },
  {
    id: 'comic-12',
    title: '桃源记',
    author: '清风抚月',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20slice%20of%20life%20cover%20of%20a%20peaceful%20ancient%20Chinese%20village%20with%20peach%20blossoms%2C%20warm%20sunlight%2C%20children%20playing%2C%20pastoral%20scene%2C%20soft%20warm%20peach%20and%20green%20tones%2C%20clean%20composition%2C%20gentle%20lighting%2C%20professional%20illustration&width=600&height=800&seq=gufeng-cover-12&orientation=portrait',
    description: '世外桃源中的悠闲日常，温暖治愈的古风生活漫画。',
    fullDescription: '在远离尘嚣的桃源村中，生活着一群性格各异的可爱村民。这里有爱管闲事的村长爷爷，有手艺精湛的糕点师傅，还有一群调皮捣蛋的孩子们。故事围绕着他们的日常生活展开，有欢笑，有泪水，有温馨，也有感动。每一话都是一个独立而温暖的小故事，如同一杯温热的茶，让人在忙碌的生活中找到片刻的宁静与治愈。',
    category: '搞笑日常',
    categorySlug: 'comedy',
    status: '连载中',
    rating: 4.5,
    totalViews: 567000,
    totalChapters: 45,
    updateTime: '2026-08-02',
    tags: ['日常', '治愈', '古风', '温馨'],
    chapters: [
      { id: 'ch-12-1', title: '第一章：桃源春暖', number: 1, updateTime: '2025-09-01' },
      { id: 'ch-12-2', title: '第二章：村长的秘密', number: 2, updateTime: '2025-09-08' },
      { id: 'ch-12-42', title: '第四十二章：收获节', number: 42, updateTime: '2026-07-18' },
      { id: 'ch-12-43', title: '第四十三章：新邻居', number: 43, updateTime: '2026-08-02' },
    ],
  },
  {
    id: 'comic-13',
    title: '厨神驾到',
    author: '食为天',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20food%20comedy%20cover%20of%20a%20cheerful%20young%20chef%20holding%20a%20steaming%20dish%20in%20an%20ancient%20Chinese%20kitchen%2C%20warm%20appetizing%20colors%2C%20delicious%20food%20illustration%2C%20clean%20composition%2C%20warm%20inviting%20lighting%2C%20professional%20illustration&width=600&height=800&seq=gufeng-cover-13&orientation=portrait',
    description: '现代大厨穿越古代，用美食征服天下！',
    fullDescription: '米其林三星主厨林凡在一场意外中穿越到了古代，成了一个落魄小餐馆的继承人。面对简陋的食材和原始的烹饪工具，林凡凭借现代烹饪知识和创意，将一道道令人惊艳的美食呈现在古代人面前。从路边小摊到京城第一酒楼，他用美食温暖了无数人的胃和心。美食画面让人食指大动，搞笑桥段令人捧腹。',
    category: '搞笑日常',
    categorySlug: 'comedy',
    status: '连载中',
    rating: 4.6,
    totalViews: 789000,
    totalChapters: 62,
    updateTime: '2026-08-01',
    tags: ['美食', '穿越', '搞笑', '日常'],
    chapters: [
      { id: 'ch-13-1', title: '第一章：穿越第一天', number: 1, updateTime: '2025-10-01' },
      { id: 'ch-13-2', title: '第二章：第一道菜', number: 2, updateTime: '2025-10-08' },
      { id: 'ch-13-58', title: '第五十八章：御膳房挑战', number: 58, updateTime: '2026-07-18' },
      { id: 'ch-13-59', title: '第五十九章：满汉全席', number: 59, updateTime: '2026-08-01' },
    ],
  },
  {
    id: 'comic-14',
    title: '血战长空',
    author: '铁血丹心',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20action%20cover%20of%20two%20warriors%20locked%20in%20an%20intense%20battle%20on%20a%20cliff%20edge%2C%20dramatic%20sky%20background%2C%20dynamic%20action%20pose%2C%20warm%20golden%20sunset%20lighting%2C%20clean%20composition%2C%20professional%20illustration&width=600&height=800&seq=gufeng-cover-14&orientation=portrait',
    description: '江湖风云再起，一场关乎天下存亡的巅峰对决。',
    fullDescription: '武林至尊之位空缺十年，天下各大门派蠢蠢欲动。曾经的剑道天才萧云在隐退十年后，被迫重出江湖。这一次，他面对的不只是武学上的较量，更是人心与道义的抉择。在血与火的洗礼中，他必须找到属于自己的剑道。战斗场面酣畅淋漓，每一个分镜都经过精心设计。',
    category: '动作热血',
    categorySlug: 'action',
    status: '连载中',
    rating: 4.5,
    totalViews: 654000,
    totalChapters: 48,
    updateTime: '2026-07-31',
    tags: ['武侠', '战斗', '热血', '江湖'],
    chapters: [
      { id: 'ch-14-1', title: '第一章：十年之约', number: 1, updateTime: '2025-12-01' },
      { id: 'ch-14-2', title: '第二章：剑出鞘', number: 2, updateTime: '2025-12-08' },
      { id: 'ch-14-45', title: '第四十五章：巅峰之战', number: 45, updateTime: '2026-07-24' },
      { id: 'ch-14-46', title: '第四十六章：一剑封喉', number: 46, updateTime: '2026-07-31' },
    ],
  },
  {
    id: 'comic-15',
    title: '绯月传说',
    author: '月下独酌',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20romance%20cover%20of%20a%20couple%20under%20a%20crimson%20moon%2C%20ancient%20Chinese%20rooftop%20setting%2C%20romantic%20yet%20melancholic%20mood%2C%20deep%20red%20and%20silver%20tones%2C%20clean%20composition%2C%20dramatic%20moonlight%2C%20professional%20illustration&width=600&height=800&seq=gufeng-cover-15&orientation=portrait',
    description: '绯月之夜许下的誓言，能否穿越轮回得到兑现？',
    fullDescription: '传说在绯月之夜，相爱的人如果对着月亮许下誓言，来世便能再次相遇。将军之女白露与敌国皇子在战场上相遇，本该是仇敌的两人却在命运的安排下相爱了。然而战争无情地分开了他们。转世轮回之后，他们能否再续前缘？画风唯美到极致的虐恋之作，每一页都值得截图收藏。',
    category: '恋爱言情',
    categorySlug: 'romance',
    status: '已完结',
    rating: 4.9,
    totalViews: 1920000,
    totalChapters: 95,
    updateTime: '2026-03-15',
    tags: ['虐恋', '轮回', '古风', '深情'],
    chapters: [
      { id: 'ch-15-1', title: '第一章：绯月之夜', number: 1, updateTime: '2025-01-01' },
      { id: 'ch-15-2', title: '第二章：战场相遇', number: 2, updateTime: '2025-01-08' },
      { id: 'ch-15-93', title: '第九十三章：轮回', number: 93, updateTime: '2026-03-08' },
      { id: 'ch-15-94', title: '第九十四章：重逢', number: 94, updateTime: '2026-03-15' },
      { id: 'ch-15-95', title: '第九十五章：绯月永恒', number: 95, updateTime: '2026-03-15' },
    ],
  },
];

export const faqItems = [
  {
    question: '古风漫画网上的漫画都是免费的吗？',
    answer: '是的！古风漫画网上的所有韩国漫画均为免费在线阅读。我们致力于为广大漫画爱好者提供优质、免费的阅读体验，无需付费订阅即可畅读所有内容。',
  },
  {
    question: '什么是下拉式观看模式？',
    answer: '下拉式观看是古风漫画网采用的一种便捷阅读模式。您只需向下滚动页面，漫画内容便会自动连续加载，无需频繁点击翻页。这种模式让阅读体验更加流畅自然，如同翻阅真实的纸质漫画。',
  },
  {
    question: '古风漫画网多久更新一次漫画？',
    answer: '我们的漫画更新频率取决于各作品的连载进度，热门连载作品通常每周更新一至两话。您可以在首页的"最近更新"栏目中查看最新的漫画更新动态。',
  },
  {
    question: '如何找到我喜欢的漫画类型？',
    answer: '您可以通过顶部的分类导航浏览不同类别的漫画，包括奇幻冒险、恋爱言情、动作热血、悬疑推理、古风奇幻和搞笑日常等分类。每个分类页面都展示了该类别下的所有漫画作品。',
  },
  {
    question: '古风漫画网支持手机阅读吗？',
    answer: '完全支持！古风漫画网采用响应式设计，可以完美适配手机、平板和电脑等各种设备。无论您使用什么设备访问，都能获得舒适的阅读体验。',
  },
  {
    question: '漫画加载缓慢怎么办？',
    answer: '如果遇到漫画加载缓慢的情况，建议您检查网络连接状态，或尝试刷新页面。我们的服务器已针对漫画图片进行了优化，正常情况下加载速度流畅。',
  },
];

export const testimonials = [
  {
    id: 't-1',
    name: '墨韵清风',
    avatar: '',
    rating: 5,
    content: '画风太美了！古风漫画网的每一部作品都像艺术品一样精致，尤其是《花间集》，每一页都想截图做壁纸。',
    date: '2026-07-15',
  },
  {
    id: 't-2',
    name: '漫画爱好者小王',
    avatar: '',
    rating: 5,
    content: '终于找到一个不用付费就能看韩国漫画的网站了！更新速度也很快，每周都在期待喜欢的作品更新。',
    date: '2026-07-20',
  },
  {
    id: 't-3',
    name: '夜雨声烦',
    avatar: '',
    rating: 4,
    content: '下拉式阅读体验真的很棒，比传统翻页舒服多了。希望能增加更多古风奇幻类的漫画！',
    date: '2026-07-25',
  },
  {
    id: 't-4',
    name: '书虫小张',
    avatar: '',
    rating: 5,
    content: '《魔道祖师》和《剑与魔法》都太好看了！网站分类清晰，找漫画很方便，已经推荐给身边所有朋友了。',
    date: '2026-07-28',
  },
  {
    id: 't-5',
    name: '月下独行',
    avatar: '',
    rating: 5,
    content: '作为一个韩漫迷，古风漫画网简直是宝藏！界面设计也很有古风韵味，阅读体验一流。',
    date: '2026-08-01',
  },
  {
    id: 't-6',
    name: '画中仙',
    avatar: '',
    rating: 4,
    content: '很喜欢网站的古风设计，看着就很舒服。《厨神驾到》搞笑又温馨，每天必刷！',
    date: '2026-08-02',
  },
];